import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityPackTypeStatusAction, Area, PlantManagerActionType, WorkPackManagerActionType } from 'src/app/Modules/idms/models/generateBarCode.model';
import { IdmApiService, UserUtilityService } from 'src/app/services';
import { ReportApiService } from 'src/app/services/report.api.service';
import { DynamicControlsComponent } from '../dynamic-controls/dynamic-controls.component';
import { PageType } from 'src/app/Modules/idms/enums/PageType';
import { BarcodeResponseModel } from 'src/app/Modules/idms/models/barcodeResponseModel';
import { APIRes } from 'src/app/Modules/idms/models/commonAPI.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ParamsApiService } from 'src/app/services/params-api.services';
import { IdmsSharedService } from 'src/app/Modules/idms/services/idms-shared.service';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { Router } from '@angular/router';
import { SaerchedTaggedItem } from 'src/app/Modules/idms/components/idms/idms-site-search/models/siteSearchTaggedItemModel';
import { BehaviorSubject, Subject, firstValueFrom } from 'rxjs';
import { elementAt, takeUntil } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';
import { PlantmanagerService } from 'src/app/Modules/idms/components/plant-manager/services/plantmanager.service';
import { ProjectmanagerService } from 'src/app/Modules/idms/components/project-manager/services/projectmanager.service';

@Component({
    selector: 'app-scan-barcode',
    templateUrl: './scan-barcode.component.html',
    styleUrls: ['./scan-barcode.component.scss'],
    standalone: false,
})
export class ScanBarcodeComponent {
    @ViewChild('scannerInput') scannerInput?: ElementRef<HTMLInputElement>;
    scanInput: string;
    barcodeValue;
    scanCompleted: boolean = false;
    scannedValue: string = '';
    barcode = '';
    lastEventTime = 0;
    scanThreshold = 100; //
    scannerCheckTimeout: any;
    destroy$ = new Subject();
    isSubscribe: Subject<any> = new Subject<any>();
    activityPackTypeStatusAction: ActivityPackTypeStatusAction = ActivityPackTypeStatusAction.None;
    isProjectManagerOpened: boolean = false;

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private modelService: NgbModal,
        private reportApiService: ReportApiService,
        private user_utility: UserUtilityService,
        private paramsApiService: ParamsApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private idmsSharedService: IdmsSharedService,
        private customToastService: CustomToastService,
        private router: Router,
        private idmApiService: IdmApiService,
        private user_utlity: UserUtilityService,
        private transLocoService: TranslocoService,
        private projectmangerService: ProjectmanagerService
    ) {
        // this.startScannerCheck();
    }

    ngOnInit(): void {
        // this.getBarcodeInfo('0N91100000075229');
        // this.ngbActiveModal.close();

        if (this.router.url.includes('idms/project-manager')) {
            this.isProjectManagerOpened = true;
        }
    }
    private scanTimeout: any;

    onScannerFocus() {
        this.scannedValue = '';

        // Start timeout: if no input within 5 seconds, show error
        this.scanTimeout = setTimeout(() => {
            if (!this.scannedValue) {
                this.user_utility.errorModelPopup(this.transLocoService.translate('IDMS.BARCODE_SCAN.BARCODE_SCANNER_NOT_DETECTED_OR_NO_INPUT_RECEIVED'));
                this.ngbActiveModal.close();
            }
        }, 20000);
    }

    onScannerInput(event: any) {
        const value = event.target.value;

        if (value) {
            clearTimeout(this.scanTimeout); // clear the timeout, input was received
            this.scannedValue = value;
        }
    }
    scanClick() {
        this.getBarcodeInfo(this.barcodeValue);
        this.ngbActiveModal.close();
    }

    ngAfterViewInit() {
        if (localStorage.getItem('currentInstanceName') == null) {
            this.ngbActiveModal.close();
            this.user_utility.errorModelPopup('Please select an instance to use barcode scanning.');
        }
        this.scannerInput?.nativeElement?.focus();
    }

    async getBarcodeInfo(barcodeNum: string) {
        try {
            let resp = await this.reportApiService.getbarcodeInfo(barcodeNum).toPromise();
            if (resp) {
                if (resp.success) {
                    switch (resp.response.instruction.area) {
                        case Area.PlantManager:
                            const plantManagerAction = resp.response.instruction.action.plantManager;
                            switch (plantManagerAction) {
                                case PlantManagerActionType.OpenEditTaggedItem:
                                    // this.router.navigate(['/idms/plantmanagerView'], {
                                    //     state: { data: resp.response },
                                    //     queryParams: { timestamp: new Date().getTime() },
                                    // });

                                    if (resp?.response?.response[0]?.namePrimary) {
                                        const payload = {
                                            start: 1,
                                            end: 10,
                                            search: resp.response.response[0].namePrimary,
                                            searchIx: 1,
                                        };
                                        this.getSearchedTaggedItems(payload);
                                    } else {
                                        this.router.navigate(['/idms/plantmanagerView'], {
                                            state: { data: resp.response },
                                            queryParams: { timestamp: new Date().getTime() },
                                        });
                                    }

                                    break;
                                case PlantManagerActionType.OpenDocumentDrawingViewer:
                                    break;
                                default:
                                    this.user_utility.errorModelPopup('No data found!!');
                                    break;
                            }
                            break;

                        case Area.WorkPackManager:
                            const workPackManagerAction = resp.response.instruction.action.workPackManager;
                            switch (workPackManagerAction) {
                                case WorkPackManagerActionType.OpenEditWorkPack:
                                case WorkPackManagerActionType.OpenEditActivityRecordExisting:
                                case WorkPackManagerActionType.OpenEditNextOrSpecificWorkflowStep:
                                    //  this.workpackManagerView(resp);

                                    if (resp?.response?.response?.namePrimary) {
                                        const payload = {
                                            start: 1,
                                            end: 10,
                                            search: resp.response.response.namePrimary,
                                            searchIx: 4,
                                        };

                                        this.getSearchedProjects(payload);
                                    } else {
                                        this.workpackManagerView(resp);
                                    }

                                    break;

                                default:
                                    this.user_utility.errorModelPopup('No data found!!');
                                    break;
                            }
                            break;

                        default:
                            break;
                    }
                } else {
                    this.user_utility.errorModelPopup(resp.message);
                }
            }
        } catch (err) {
            this.user_utility.errorModelPopup(err.message);
        }
    }

    async workpackManagerView(resp: APIRes<BarcodeResponseModel>) {
        const taggedItem = resp.response.instruction.trail.find((x: any) => x.entityType === 'TaggedItem');

        this.activityPackTypeStatusAction = resp.response.instruction.activityPackTypeStatusAction;

        let permission =
            resp.response.instruction.activityPackTypeStatusAction == ActivityPackTypeStatusAction.Create ||
            resp.response.instruction.activityPackTypeStatusAction == ActivityPackTypeStatusAction.Modify
                ? true
                : false;

        const taggedItemId = taggedItem?.id;
        let TaggedItemData = null;
        if (taggedItemId) {
            let result = await this.idmApiService.GetTaggedItemDataById(taggedItemId).toPromise();
            TaggedItemData = result.response;
            if (resp.response.response.schemaVersion.latestSchemaVersionId)
                TaggedItemData['activityPackTaggedItemActivityLatestSchemaVersionId'] = resp.response.response.schemaVersion.latestSchemaVersionId;
            if (resp.response.response.schemaVersion.schemaVersionId)
                TaggedItemData['activityPackTaggedItemActivitySchemaVersionId'] = resp.response.response.schemaVersion.schemaVersionId;
        }

        let dialogRef = this.modelService.open(DynamicControlsComponent, {
            size: 'xl',
            backdrop: 'static',
        });

        dialogRef.componentInstance.jsonString = resp.response.response.schemaVersion.schema;
        dialogRef.componentInstance.mode = 'pop-up';
        dialogRef.componentInstance.permission = permission;
        dialogRef.componentInstance.PageType = resp.response.response.activityPackTaggedItemActivityId
            ? PageType.EditActivityTaggedItem
            : PageType.AddActivityTaggedItem;
        dialogRef.componentInstance.pagetitle = 'Activity Records';
        dialogRef.componentInstance.DataContent = resp.response.response.dataContent;
        dialogRef.componentInstance.trail = resp.response.instruction.trail;
        dialogRef.componentInstance.TaggedItemData = TaggedItemData;
        dialogRef.componentInstance.activityPackRecordDetails = TaggedItemData;
        dialogRef.componentInstance.isSaveDisable = !permission;
        dialogRef.componentInstance.activityPackTypeStatusAction = resp.response.instruction.activityPackTypeStatusAction;

        dialogRef.componentInstance.preCloseSaveHandler = async (result) => {
            if (!result) return false;
            if (result.images.length) {
                let images = result.images;
                let url: string = '';
                return this.idmsSharedService
                    .getBlobImageUrl(images)
                    .toPromise()
                    .then(async (res) => {
                        if (res.success) {
                            url = url == '' ? url + res.response.path : url + ',' + res.response.path;
                            result.ImageUrl = url;

                            let data = this.idmsSharedService.extractGroupData(result.schemsForm.value, result);
                            data.Datas = data.Datas.replace(/}{/g, ',');

                            let payload: any = {
                                dataContent: data.Datas,
                                schemaVersionId: resp.response.response.schemaVersion.schemaVersionId,
                                //  activityPackTaggedItemId: resp.response.response.activityPackTaggedItemId,
                                activityPackTaggedItemActivityId: resp.response.response.activityPackTaggedItemActivityId,
                            };

                            return await this.postactivitypacktaggeditemApiCall([payload]);
                        } else {
                            this.user_utility.errorModelPopup(res.message);
                            return false;
                        }
                    })
                    .catch((e) => {
                        console.warn(e);
                        return false;
                    });
            } else {
                let data = this.idmsSharedService.extractGroupData(result.schemsForm.value, result);
                data.Datas = data.Datas.replace(/}{/g, ',');

                let payload: any = {
                    dataContent: data.Datas,
                    schemaVersionId: resp.response.response.schemaVersion.schemaVersionId,
                    //  activityPackTaggedItemId: resp.response.response.activityPackTaggedItemId,
                    activityPackTaggedItemActivityId: resp.response.response.activityPackTaggedItemActivityId,
                };
                // let finalpaylod = this.findingAndmakingpayload(item, payload);

                if (this.activityPackTypeStatusAction === ActivityPackTypeStatusAction.Create) {
                    let payload: any = {
                        dataContent: data.Datas,
                        schemaVersionId: resp.response.response.schemaVersion.schemaVersionId,
                        activityPackTaggedItemId: resp.response.response.activityPackTaggedItemId,
                    };
                    return await this.postactivitypacktaggeditemApiCall([payload]);
                } else {
                    let payload: any = {
                        dataContent: data.Datas,
                        schemaVersionId: resp.response.response.schemaVersion.schemaVersionId,
                        activityPackTaggedItemActivityId: resp.response.response.activityPackTaggedItemActivityId,
                    };

                    return await this.putactivitypacktaggeditemactivitiesApicall([payload]);
                }
            }
        };

        dialogRef.result
            .then(async (result) => {})
            .catch((e) => {
                console.warn(e);
            });
    }

    async postactivitypacktaggeditemApiCall(activityPackTaggedPayload): Promise<boolean> {
        this.ngxUiLoaderService.start();
        try {
            let res: any = await this.paramsApiService.postactivitypacktaggeditem(activityPackTaggedPayload).toPromise();
            if (res.success) {
                if (res?.approvalAction && res?.approvalAction > 0 && res?.approvalAction <= 2) {
                    this.customToastService.successToast(res.message, 'Success');
                } else {
                    this.customToastService.successToast('Activity record(s) created successfully!', 'Success');
                }
                this.ngxUiLoaderService.stop();

                if (this.isProjectManagerOpened) {
                    this.reLoad();
                }
                return true;
            } else {
                this.ngxUiLoaderService.stop();
                this.customToastService.errorToast(
                    res?.message || 'Unable to create activity record(s). Please try again later or contact system administrator.',
                    'Error'
                );
                return false;
            }
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Unable to create activity record(s). Please try again later or contact system administrator.', 'Error');
            return false;
        }
    }

    async putactivitypacktaggeditemactivitiesApicall(activityPackTaggedPayload): Promise<boolean> {
        this.ngxUiLoaderService.start();
        try {
            let res: any = await this.paramsApiService.putactivitypacktaggeditemactivities(activityPackTaggedPayload).toPromise();
            if (res.success) {
                if (res?.approvalAction && res?.approvalAction > 0 && res?.approvalAction <= 2) {
                    this.customToastService.successToast(res.message, 'Success');
                } else {
                    this.customToastService.successToast('Activity record(s) updated successfully!', 'Success');
                }
                this.ngxUiLoaderService.stop();

                if (this.isProjectManagerOpened) {
                    this.reLoad();
                }
                return true;
            } else {
                this.ngxUiLoaderService.stop();
                this.customToastService.errorToast(
                    res?.message || 'Unable to update activity record(s). Please try again later or contact system administrator.',
                    'Error'
                );
                return false;
            }
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Unable to create activity record(s). Please try again later or contact system administrator.', 'Error');
            return false;
        }
    }

    reLoad() {
        this.projectmangerService.isActivityPackSaved.next(true);
    }

    onStarted(started) {}

    onError(error) {
        console.error('Err *******->', error);
    }

    closeClick() {
        this.ngbActiveModal.close();
    }

    clearInput(): void {
        this.scannedValue = '';
    }

    onScanComplete(event: any): void {
        const inputElement = event.target as HTMLInputElement;
        this.scannedValue = inputElement.value.trim();
        inputElement.value = '';
        this.ngbActiveModal.close();
        this.barcodeValue = this.scannedValue;
        this.getBarcodeInfo(this.scannedValue);
        this.scanCompleted = true;
    }

    handleClick(event: MouseEvent): void {
        const clickedElement = event.target as HTMLElement;
        const inputElement = this.scannerInput?.nativeElement;
        if (!inputElement) {
            return;
        }
        if (clickedElement !== inputElement) {
            inputElement.focus();
        }
    }
    // barcodeData: string = '';
    // typingTimer: any;
    // @HostListener('document:keypress', ['$event'])
    // onKeyPress(event: KeyboardEvent) {
    //     const char = event.key;
    //     this.barcodeData += char;

    //     clearTimeout(this.typingTimer);
    //     this.typingTimer = setTimeout(() => {
    //         if (this.barcodeData.length > 5) {
    //             console.log('Possible barcode scanned:', this.barcodeData);
    //             this.handleBarcode(this.barcodeData);
    //         }
    //         this.barcodeData = '';
    //     }, 50); // Barcode scanner types fast; human typing is slower
    // }
    // handleBarcode(barcode: string) {
    //     // Handle the barcode logic here (API call, validation, etc.)
    //     alert(`Scanned Barcode: ${barcode}`);
    //     // You can reset input field, update UI, etc.
    // }
    onKey(event: any) {
        this.barcode = event.target.value;
    }
    // startScannerCheck() {
    //     this.scanTimeout = setTimeout(() => {
    //         if (!this.barcodeValue) {
    //             this.user_utility.errorModelPopup('Barcode scanner not found!!');
    //             this.ngbActiveModal.close();
    //         }
    //     }, 5000); // Wait 5 seconds
    // }
    // // barcodeValue = '';
    // errorMessage = '';
    // scanTimeout: any;
    // onInputChange(event: any): void {
    //     clearTimeout(this.scanTimeout);
    //     this.barcodeValue = event.target.value;
    //     this.errorMessage = '';
    // }
    // @HostListener('window:keydown', ['$event'])
    // handleKeyboardEvent(event: KeyboardEvent) {
    //     const currentTime = new Date().getTime();

    //     if (currentTime - this.lastEventTime > this.scanThreshold) {
    //         this.barcode = ''; // Reset if delay is too long
    //     }

    //     if (event.key === 'Enter' && this.barcode) {
    //         console.log('Scanned Barcode:', this.barcode);
    //         this.barcode = '';
    //         clearTimeout(this.scannerCheckTimeout);
    //         this.startScannerCheck(); // Restart the timeout for next detection
    //     } else {
    //         this.barcode += event.key;
    //     }

    //     this.lastEventTime = currentTime;
    // }

    // startScannerCheck() {
    //     clearTimeout(this.scannerCheckTimeout);
    //     this.scannerCheckTimeout = setTimeout(() => {
    //         this.user_utility.errorModelPopup('Barcode scanner not found!!');
    //         this.ngbActiveModal.close();
    //     }, 5000); // Timeout after 5 seconds if no scanner input
    // }

    async getSearchedTaggedItems(payload) {
        this.ngxUiLoaderService.start();
        try {
            try {
                let resp = await firstValueFrom(this.idmApiService.searchnames(payload));

                if (resp?.success) {
                    localStorage.setItem('taggedItemHierarchy', JSON.stringify(resp.response.data[0].hierarchy));
                    localStorage.setItem('taggedItemId', resp.response.data[0].taggedItemId);
                    const url = `/idms/plantmanager`;
                    // ensure the URL is a blob created by us to prevent open redirect
                    // if (url && url.startsWith('blob:')) {
                    window.open(url, '_blank', 'noopener,noreferrer');
                    // }
                    //  window.open(url, '_self');
                } else if (resp?.message) {
                    this.user_utlity.errorModelPopup(resp.message);
                }
            } catch (err) {
                console.error('API Error:', err);
            }
            this.ngxUiLoaderService.stop();
        } catch (err) {
            this.ngxUiLoaderService.stop();
        }
    }

    async getSearchedProjects(payload) {
        this.ngxUiLoaderService.start();
        try {
            let projects = await this.idmApiService.searchnames(payload).toPromise();
            if (projects?.success) {
                const a = projects.response.data[0];

                const activitypack = a.activityPacks.find((ap) => ap.activityPack === payload.search);

                const url = `/idms/project-manager/${a.projectId}/workpack/${activitypack.activityPackId}?index=0`;
                // ensure the URL is a blob created by us to prevent open redirect
                // if (url && url.startsWith('blob:')) {
                window.open(url, '_blank', 'noopener,noreferrer');
                // }
            } else if (projects?.message) {
                this.user_utlity.errorModelPopup(projects.message);
            }
            this.ngxUiLoaderService.stop();
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.unsubscribe();
    }
}
